/* @noflow FIXME after Flow 56 merged */
import * as React from 'react';
import { removeFilter, flushFilters } from 'reducers/tables';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Link from 'components/Link';
import Glyph from 'components/Glyph';
import type { Filters, Filter } from 'reducers/tables';

import './styles/SmartTableFilterTokens.scss';

type Props = {
  filters: Filters,
  namespace: string,
  flushFilters: (namespace: string) => any,
  removeFilter: (namespace: string, filter: Filter) => any,
};

function Token(props: { text?: string, onClose: Function }) {
  return (
    <Link className="SmartTableFilterTokens-item" eventElementName="SmartTableFilterTokens-item">
      {props.text && <span className="SmartTableFilterTokens-item-text">{props.text}</span>}
      <Glyph name="close" size="xxsmall" onClick={props.onClose} />
    </Link>
  );
}

class SmartTableFilterTokens extends React.Component<Props> {
  flush = () => {
    this.props.flushFilters(this.props.namespace);
  };
  removeFilter = (filter: Filter) => {
    this.props.removeFilter(this.props.namespace, filter);
  };
  render() {
    const { filters } = this.props;

    if (filters.size === 0) {
      return null;
    }

    return (
      <div className="SmartTableFilterTokens">
        <Token onClose={this.flush} />
        {this.props.filters
          .valueSeq()
          .toArray()
          .map(filter => (
            <Token key={filter.key} text={filter.name} onClose={() => this.removeFilter(filter)} />
          ))}
      </div>
    );
  }
}

function mapStateToProps(state: Object, props: Props) {
  return {
    filters: state.tables.get(props.namespace).filters,
  };
}

function mapDispatchToProps(dispatch: Function) {
  // $FlowFixMe
  return bindActionCreators({ removeFilter, flushFilters }, dispatch);
}

export { SmartTableFilterTokens };
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmartTableFilterTokens);
